const PERMISSION_KEY= "personalize:watchlist";
const PAGE_URL = {
    WATCHLIST_PAGE: "/admin/personalize/watchlist"
}

export {PERMISSION_KEY, PAGE_URL}

